import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import SuccessScoringReasonList from "./SuccessScoringReasonList";
import SuccessScoringReasonDetail from "./SuccessScoringReasonDetail";
export const getSuccessScoringReasonBasePath = () => `${getAdminBasePath()}/successScoringReason`;
export const getSuccessScoringReasonBaseRoute = () => `${getAdminBaseRoute()}/successScoringReason`;
export const getSuccessScoringReasonIndexRoute = () => `${getSuccessScoringReasonBaseRoute()}`;
export const getSuccessScoringReasonIndexPath = () => `${getSuccessScoringReasonBasePath()}`;
export const getSuccessScoringReasonDetailPath = (id) => `${getSuccessScoringReasonBasePath()}/${id}`;
export const getSuccessScoringReasonDetailRoute = () => `${getSuccessScoringReasonBaseRoute()}/:id`;
const AdminSuccessScoringReasonRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: SuccessScoringReasonDetail, path: getSuccessScoringReasonDetailRoute() }), _jsx(Route, { component: SuccessScoringReasonList, path: getSuccessScoringReasonIndexRoute() })] }));
};
export default AdminSuccessScoringReasonRoutes;
